// 日报管理 API 扩展
import { createAppRequest } from '@/services/request';
import type {
  CreateDailyReportDto,
  DailyReportData,
  DailyReportStatistics,
  QueryDailyReportDto,
  UpdateDailyReportDto,
} from './type';

const request = createAppRequest();

// 日报管理 API
export const dailyReportApi = {
  // 获取日报列表
  getDailyReports: (params?: QueryDailyReportDto) =>
    request<{ reports: DailyReportData[]; total: number }>(
      '/bff/daily-reports',
      {
        method: 'GET',
        params,
      },
    ),

  // 获取特定日期的日报
  getDailyReport: (date: string, userId?: string) =>
    request<DailyReportData>(`/bff/daily-reports/${date}`, {
      method: 'GET',
      params: userId ? { userId } : undefined,
    }),

  // 创建日报
  createDailyReport: (data: CreateDailyReportDto) =>
    request<DailyReportData>('/bff/daily-reports', {
      method: 'POST',
      data,
    }),

  // 更新日报
  updateDailyReport: (date: string, data: UpdateDailyReportDto) =>
    request<DailyReportData>(`/bff/daily-reports/${date}`, {
      method: 'PATCH',
      data,
    }),

  // 删除日报
  deleteDailyReport: (date: string, userId?: string) =>
    request<void>(`/bff/daily-reports/${date}`, {
      method: 'DELETE',
      params: userId ? { userId } : undefined,
    }),

  // 获取日报统计
  getDailyReportStatistics: (
    userId?: string,
    dateFrom?: string,
    dateTo?: string,
  ) =>
    request<DailyReportStatistics>('/bff/daily-reports/statistics', {
      method: 'GET',
      params: { userId, dateFrom, dateTo },
    }),

  // 批量导出日报
  exportDailyReports: (params: QueryDailyReportDto) =>
    request<Blob>('/bff/daily-reports/export', {
      method: 'GET',
      params: {
        userId: params.userId,
        dateFrom: params.dateFrom,
        dateTo: params.dateTo,
      },
      responseType: 'blob',
    }),

  // 自动生成日报模板
  generateDailyReportTemplate: (date: string, userId?: string) =>
    request<DailyReportData>(`/bff/daily-reports/generate-template/${date}`, {
      method: 'POST',
      params: userId ? { userId } : undefined,
    }),
};
